import React, { useContext, useEffect, useState } from "react";
import { GlobalContext } from "../../Context/GlobalState";
import { billpunchbasicauth } from "../../utils/Credentials";
import { BASE_URL_API_TRANXT_UAT_API } from "../../utils/Constant";

import { Button, Form, Modal, Table } from "react-bootstrap";
import swal from "sweetalert";
import { ViewBalanceleave } from "../Admin/Salarytable";
const Balanceleave = () => {
  const { user, setTransactionLoaderState } = useContext(GlobalContext);
  const [data, setData] = useState([]);
  const { password, username } = billpunchbasicauth;
  const [showModal, setShowModal] = useState(false);
  const handleShow = () => setShowModal(true);
  const handleClose = () => setShowModal(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [hasSearched, setHasSearched] = useState(false);
  const currentYear = new Date().getFullYear();
const [selectedYear, setSelectedYear] = useState(currentYear);

const yearOptions = Array.from({ length: 6 }, (_, i) => currentYear - 3 + i);
  const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth() + 1);
  const monthOptions = [
    { name: "January", value: 1 },
    { name: "February", value: 2 },
    { name: "March", value: 3 },
    { name: "April", value: 4 },
    { name: "May", value: 5 },
    { name: "June", value: 6 },
    { name: "July", value: 7 },
    { name: "August", value: 8 },
    { name: "September", value: 9 },
    { name: "October", value: 10 },
    { name: "November", value: 11 },
    { name: "December", value: 12 },
  ];
  const getbalanceleave = async () => {
    setTransactionLoaderState(true);
    try {
      const base64Credentials = btoa(`${username}:${password}`);

      var raw = JSON.stringify({
        empid: String(0),
        firmid: String(user.firm_id),
        month: String(selectedMonth),
        year: String(selectedYear)
      });

      var requestOptions = {
        method: "POST",
        headers: {
          Authorization: `Basic ${base64Credentials}`,
          "Content-Type": "application/json",
        },
        body: raw,
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/Salary/GetLeaveBalance`,
        requestOptions
      );
      const data = await res.json();
      if (data.status === "0") {
        setData(data.data);
      } else {
        setData([]);
      }
      setTransactionLoaderState(false);
    } catch (error) {
      console.log("error", error);
    }
    setTransactionLoaderState(false);
  };


  const handleFilterSearch = () => {
    setHasSearched(true);
    getbalanceleave();
  };

  const handleSearchInputChange = (event) => {
    setSearchQuery(event.target.value);
  };
  const filteredData = data.filter((item) =>
    (item.fullname || "").toLowerCase().includes(searchQuery.toLowerCase())
  );
  return (
    <>
      <div>
        <div className=" row mt-5">
          <h5 className="col-3 d-flex align-items-center ">
            {" "}
            Balance Leave of Employees
          </h5>

          <div className=" col mr-md-4 mr-sm-3 d-flex justify-content-end">
            <select
              className="form-select"
              style={{
                width: "200px",
                height: "2rem",
                fontSize: "0.875rem",
                marginRight: "12px",
              }}
              value={selectedMonth}
              onChange={(e) => setSelectedMonth(Number(e.target.value))}
            >
              {monthOptions.map((month) => (
                <option key={month.value} value={month.value}>
                  {month.name}
                </option>
              ))}
            </select>
            <select
  className="form-select ml-2"
  style={{ width: "120px", height: "2rem", fontSize: "0.875rem" }}
  value={selectedYear}
  onChange={(e) => setSelectedYear(Number(e.target.value))}
>
  {yearOptions.map((year) => (
    <option key={year} value={year}>
      {year}
    </option>
  ))}
</select>
<Button
  variant="secondary"
  size="sm"
  className="ml-2"
  onClick={handleFilterSearch}
  style={{ marginLeft: "12px" }}
>
  Search
</Button>
            <div className="px-2">
              <input
                className="form-control"
                style={{
                  background: "#fff",
                  borderRadius: ".4rem",
                  border: "1px #ced4da solid",
                  paddingLeft: "10px",
                  height: "2rem",
                }}
                type="text"
                placeholder="Search"
                value={searchQuery}
                onChange={handleSearchInputChange}
              />
            </div>
            <Button
              variant="primary"
              size="sm"
              onClick={handleShow}
              className="ml-3"
            >
              Generate Leave
            </Button>
          </div>
        </div>

        <div
          className=" p-0 "
          style={{
            borderTopLeftRadius: "1rem",
            borderTopRightRadius: "1rem",
          }}
        >
          <ViewBalanceleave
            data={hasSearched ? filteredData : []}
            Getbalanceleave={getbalanceleave}
          />
          <GenerateLeaveModal
            show={showModal}
            handleClose={handleClose}
            getbalanceleave={getbalanceleave}
            handleGenerate={(selectedEmployees, selectedMonth) => {
              console.log(
                "Final Submission: ",
                selectedEmployees,
                selectedMonth
              );
            }}
          />
        </div>
      </div>
    </>
  );
};
const GenerateLeaveModal = ({ show, handleClose, getbalanceleave }) => {
  const { user, setTransactionLoaderState } = useContext(GlobalContext);
  const { username, password } = billpunchbasicauth;

  const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth() + 1);
  const [employeeData, setEmployeeData] = useState([]);
  const [selectedEmployees, setSelectedEmployees] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const currentYear = new Date().getFullYear();
  const [selectedYear, setSelectedYear] = useState(currentYear);
  const years = Array.from({ length: 6 }, (_, i) => currentYear - 3 + i); 
  const months = [
    { name: "January", value: 1 },
    { name: "February", value: 2 },
    { name: "March", value: 3 },
    { name: "April", value: 4 },
    { name: "May", value: 5 },
    { name: "June", value: 6 },
    { name: "July", value: 7 },
    { name: "August", value: 8 },
    { name: "September", value: 9 },
    { name: "October", value: 10 },
    { name: "November", value: 11 },
    { name: "December", value: 12 },
  ];

  // Fetch employee list
  const getEmployeeList = async () => {
    setTransactionLoaderState(true);
    try {
      const base64Credentials = btoa(`${username}:${password}`);

      const raw = JSON.stringify({ firmId: user.firm_id });

      const requestOptions = {
        method: "POST",
        headers: {
          Authorization: `Basic ${base64Credentials}`,
          "Content-Type": "application/json",
        },
        body: raw,
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/Salary/getEmployee`,
        requestOptions
      );
      const data = await res.json();

      if (data.status === "0") {
        setEmployeeData(data.data);
      } else {
        setEmployeeData([]);
      }
    } catch (error) {
      console.error("Error fetching employees", error);
    }
    setTransactionLoaderState(false);
  };

  useEffect(() => {
    if (show) {
      getEmployeeList();
      setSelectedEmployees([]);
      setSelectAll(false);
    }
  }, [show]);

  const handleCheckboxChange = (empid) => {
    setSelectedEmployees((prev) => {
      const updated = prev.includes(empid)
        ? prev.filter((id) => id !== empid)
        : [...prev, empid];

      // Automatically update selectAll if all are selected or not
      setSelectAll(updated.length === employeeData.length);
      return updated;
    });
  };

  // Select/Deselect All
  const handleSelectAll = () => {
    if (selectAll) {
      setSelectedEmployees([]);
    } else {
      const allIds = employeeData.map((emp) => emp.empid);
      setSelectedEmployees(allIds);
    }
    setSelectAll(!selectAll);
  };
  const onGenerateClick = async () => {
    if (selectedEmployees.length === 0) {
      console.warn("No employees selected.");
      swal("No employees selected", "Please select at least one employee.", "warning");
      return;
    }
  
    const base64Credentials = btoa(`${username}:${password}`);
    const currentYear = new Date().getFullYear();
  
    const payload = {
      requests: selectedEmployees.map((empid) => ({
        empid: empid,
        firmid: user.firm_id,
        month: selectedMonth.toString(),
        year: selectedYear.toString(),
      })),
    };
  
    // console.log("🚀 Payload to be sent:", payload);
  
    setTransactionLoaderState(true);
  
    try {
      console.log("🔁 Calling API...");
      const response = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/Salary/GenerateLeaveBalance`,
        {
          method: "POST",
          headers: {
            Authorization: `Basic ${base64Credentials}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        }
      );
  
      // console.log("✅ Raw API response object:", response);
  
      const result = await response.json();
      // console.log("📦 Parsed API response JSON:", result);
  
      if (result?.status === "0") {
        // console.info("🎉 Leave balance generated successfully.");
        swal("Success", "Leave balance generated successfully.", "success");
      } else {
        // console.error("⚠️ API responded with error:", result?.message);
        swal("Error", result?.message || "Failed to generate leave balance.", "error");
      }
  
      getbalanceleave();
      handleClose();
    } catch (error) {
      console.error("❌ Error during API call:", error);
      swal("API Error", "Something went wrong while generating leave balance.", "error");
    } finally {
      setTransactionLoaderState(false);
      console.log("🟡 Loader state reset to false.");
    }
  };
  
  

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Generate Leave</Modal.Title>
      </Modal.Header>
      <Modal.Body>
      <div className="d-flex align-items-center gap-2 mb-3">

<Form.Select
  value={selectedMonth}
  onChange={(e) => setSelectedMonth(Number(e.target.value))}
  style={{ width: "180px" }}
>
  {months.map((month) => (
    <option key={month.value} value={month.value}>
      {month.name}
    </option>
  ))}
</Form.Select>

<Form.Select
  value={selectedYear}
  onChange={(e) => setSelectedYear(Number(e.target.value))}
  style={{ width: "120px" }}
>
  {years.map((year) => (
    <option key={year} value={year}>
      {year}
    </option>
  ))}
</Form.Select>

<Button variant="success" size="sm" onClick={onGenerateClick}>
  Generate
</Button>

</div>

        <div
          style={{ overflow: "auto", scrollbarWidth: "none", height: "70vh" }}
        >
          <Table size="sm">
            <thead
              style={{
                position: "sticky",
                top: 0,
                backgroundColor: "#f8f9fa",
                zIndex: 1,
              }}
            >
              <tr>
                <th
                  style={{
                    position: "sticky",
                    top: 0,
                    backgroundColor: "#f8f9fa",
                    zIndex: 2,
                  }}
                >
                  <Form.Check
                    type="checkbox"
                    checked={selectAll}
                    onChange={handleSelectAll}
                  />
                </th>
                <th
                  style={{
                    position: "sticky",
                    top: 0,
                    backgroundColor: "#f8f9fa",
                    zIndex: 2,
                  }}
                >
                  Name
                </th>
              </tr>
            </thead>
            <tbody>
              {employeeData.map((emp) => (
                <tr key={emp.empid}>
                  <td>
                    <Form.Check
                      type="checkbox"
                      checked={selectedEmployees.includes(emp.empid)}
                      onChange={() => handleCheckboxChange(emp.empid)}
                    />
                  </td>
                  <td style={{ fontSize: ".9rem" }}>
                    {`${emp.firstname ?? ""} ${emp.lastname ?? ""}`}
                  </td>
                </tr>
              ))}
              {employeeData.length === 0 && (
                <tr>
                  <td colSpan="2" className="text-center">
                    No employees found.
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
      </Modal.Body>
    </Modal>
  );
};
export default Balanceleave;
